import React from 'react';
import ReactDOM from 'react-dom';
import PaymentProcessing from '../components/cart/PaymentProcessing';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderPaymentProcessing = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<PaymentProcessing props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering PaymentProcessing:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};